export default "__VITE_ASSET__057bf8fd__"